import { Route, Routes } from 'react-router-dom';
import {
  isServiceLevelDefinitionsEnabled,
  useLoadAdminSettingsQuery,
} from 'redux/services/settingsApi';
import Spinner from '@/components/global/Spinner/Spinner';
import NotFoundPage from '../NotFoundPage/NotFoundPage';
import ServiceLevelsDashboardPage from './ServiceLevelsDashboardPage/ServiceLevelsDashboardPage';
import ServiceLevelFormPage from './ServiceLevelFormPage/ServiceLevelFormPage';

function ServiceLevelsPage() {
  const { data: adminSettings, isLoading } = useLoadAdminSettingsQuery();

  if (isLoading) {
    return <Spinner position="centerAbsolute" size="large" />;
  }

  if (!isServiceLevelDefinitionsEnabled(adminSettings)) {
    return <NotFoundPage />;
  }

  return (
    <Routes>
      <Route index element={<ServiceLevelsDashboardPage />} />
      <Route path="create" element={<ServiceLevelFormPage />} />
      <Route path=":serviceLevelId" element={<ServiceLevelFormPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default ServiceLevelsPage;
